import clsx from "clsx";
import Company from "components/atoms/Company";
import { companyList } from "data";

const Trusted = () => {
    return (
        <section className="trusted w-full bg-neutral-20 relative z-50 tablet:h-[307px] phone:h-[307px]">
            <div className={clsx(
                "w-full max-w-[1440px] mx-auto",
                "py-12 tablet:py-12 desktop:py-16 px-6 tablet:px-8 desktop:px-[140px]"
            )}>
                <p className="text-heading-5 text-neutral-50 text-center phone:pb-8 pb-10 tablet:pb-8 font-medium phone:text-[18px] tablet:text-[18px] phone:leading-[30.6px] leading-[28.8px] tablet:leading-[30.6px]">Trusted by</p>
                <div className="hidden overflow-hidden md:grid grid-cols-5 tablet:gap-[24px] gap-8">
                    {companyList.map((item) => (
                        <Company key={item.id} title={item.title} />
                    ))}
                </div>
                <div className="grid md:hidden grid-cols-3 gap-4 phone:gap-5">
                    {companyList.slice(0, 9).map((item) => (
                        <Company key={item.id} title={item.title} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Trusted;